/*スライダー*/
//FV
document.addEventListener('DOMContentLoaded', function() {
  const fvSwiper = new Swiper('.fv_swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides : true,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints:{
      769:{
        slidesPerView: 1.2,
      },
      1201:{
        slidesPerView: 1.6,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
});
//TOP商品リスト
document.addEventListener('DOMContentLoaded', function() {
  const fvSwiper = new Swiper('.top_item_swiper', {
    slidesPerView: 1.4,
    spaceBetween: 15,
    centeredSlides : true,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints:{
      769:{
        spaceBetween: 30,
        slidesPerView: 1.8,
      },
      1201:{
        spaceBetween: 50,
        slidesPerView: 2.4,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});


/*ヘッダー*/
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");
  const headerSmp = document.querySelector(".header_smp");
  const hamburger = document.getElementById("hamburger");
  const headerMain = document.querySelector(".header_main");
  const navLinks = document.querySelectorAll("nav > ul > li > a");

  // --- ヘッダー固定用（bodyを下げる） ---
  function adjustBodyPadding() {
    if (header) {
      const headerHeight = header.offsetHeight;
      document.body.style.paddingTop = headerHeight + "px";
      adjustHeaderMainMaxHeight();
    }
  }

  // --- .header_mainの最大高さ調整（スマホのみ） ---
  function adjustHeaderMainMaxHeight() {
    if (!headerMain) return;

    if (headerMain.classList.contains("active") && window.innerWidth < 993) {
      const smpHeight = headerSmp ? headerSmp.offsetHeight : 0;
      const maxHeight = window.innerHeight - smpHeight;
      headerMain.style.maxHeight = maxHeight + "px";
      headerMain.style.overflowY = "auto"; // 長い場合はスクロール可能
    } else {
      headerMain.style.maxHeight = "";
      headerMain.style.overflowY = "";
    }
  }

  window.addEventListener("load", adjustBodyPadding);
  window.addEventListener("resize", adjustBodyPadding);

  // --- ハンバーガーメニュー（スマホ用） ---
  if (hamburger && headerMain) {
    hamburger.addEventListener("click", function (e) {
      e.preventDefault();
      hamburger.classList.toggle("active");
      headerMain.classList.toggle("active");
      adjustHeaderMainMaxHeight();
    });
  }

  // --- ドロップダウンメニュー（PC/スマホ共通） ---
  navLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      if (this.getAttribute("href") === "#") e.preventDefault();

      const parentLi = this.parentElement;
      if (parentLi.classList.contains("active")) {
        parentLi.classList.remove("active");
      } else {
        navLinks.forEach(l => l.parentElement.classList.remove("active"));
        parentLi.classList.add("active");
      }

      adjustHeaderMainMaxHeight();
    });
  });

  // --- 画面リサイズ時のリセット処理 ---
  function resetMenuOnResize() {
    if (window.innerWidth >= 993) {
      if (hamburger) hamburger.classList.remove("active");
      if (headerMain) headerMain.classList.remove("active");
    } else {
      navLinks.forEach(l => l.parentElement.classList.remove("active"));
    }
    adjustBodyPadding();
  }
  window.addEventListener("resize", resetMenuOnResize);

  // --- スクロール時にheaderへクラスを付与 ---
  function toggleHeaderScroll() {
    const topPagePath = "/";
    if (window.location.pathname.endsWith(topPagePath)) {
      if (window.scrollY > 0) {
        header.classList.add("scroll");
      } else {
        header.classList.remove("scroll");
      }
    } else {
      header.classList.add("scroll");
    }
  }
  window.addEventListener("scroll", toggleHeaderScroll);
  window.addEventListener("load", toggleHeaderScroll);
});


/*アコーディオン(フッター、スマホハンバーガー内)*/
document.addEventListener("DOMContentLoaded", function() {
    // 共通関数：クリックでactive切替 + PCで強制active
    function setupToggle(containerSelector, triggerSelector, targetSelector) {
        const containers = document.querySelectorAll(containerSelector);

        function setInitialState() {
            const isPC = window.innerWidth >= 993;
            containers.forEach(container => {
                const trigger = container.querySelector(triggerSelector);
                const target = container.querySelector(targetSelector);
                if (!trigger || !target) return;
                if (isPC) {
                    trigger.classList.add("active");
                    target.classList.add("active");
                } else {
                    trigger.classList.remove("active");
                    target.classList.remove("active");
                }
            });
        }
        containers.forEach(container => {
            const trigger = container.querySelector(triggerSelector);
            const target = container.querySelector(targetSelector);
            if (!trigger || !target) return;
            trigger.addEventListener("click", function() {
                if (window.innerWidth < 993) {
                    trigger.classList.toggle("active");
                    target.classList.toggle("active");
                }
            });
        });

        window.addEventListener("resize", setInitialState);
        setInitialState();
    }
    // フッター用
    setupToggle(".footer_guide .col", "h3", ".contents");
    // サイド用
    setupToggle(".side_nav .list_wrap", "p", "ul");
    // ハンバーガーメニュー内用
    setupToggle(".dropdown_menu_list .list_wrap", "p", "ul");
});

document.addEventListener("DOMContentLoaded", function () {
  const stockTitle = document.querySelector(".stock_price > p");
  const contents = document.querySelector(".stock_price .contents");
  stockTitle.classList.add("active");
  contents.classList.add("active");

  stockTitle.addEventListener("click", function () {
    stockTitle.classList.toggle("active");
    contents.classList.toggle("active");
  });
});


/*スムーススクロール*/
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector("header");
  document.querySelectorAll("a[href^='#']").forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const href = anchor.getAttribute("href");
      const target = (href === "#" || href === "") ? document.body : document.querySelector(href);
      if (target) {
        const headerHeight = header ? header.offsetHeight : 0;
        const position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: position,
          behavior: "smooth"
        });
      }
    });
  });
});